import { ReactComponent as GreenTick } from "../img/icons/icon_tick_green.svg";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

function Email({ onSubmitHandler, initState = null }) {
  const [state, setState] = useState(
    initState || {
      email: "",
      confirmEmail: "",
      none: false,
    }
  );
  const [inputType1, setInput1Type] = useState("email");
  const [inputType2, setInput2Type] = useState("email");

  const [validation, setValidation] = useState({
    message: "",
    status: true,
  });

  const { t } = useTranslation();

  useEffect(() => {
    validator();
  }, [state]);

  function validateEmail(inputText) {
    let mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,15})+$/;
    return inputText.match(mailformat);
  }

  function validator() {
    if (state.none) {
      setValidation({
        message: "",
        status: true,
      });
    } else if (state.email === "" || state.confirmEmail === "") {
      setValidation({
        message: t("appointment.EMAIL-VALIDATION.message1"),
        status: false,
      });
    } else if (
      !validateEmail(state.email) ||
      !validateEmail(state.confirmEmail)
    ) {
      setValidation({
        message: t("appointment.EMAIL-VALIDATION.message2"),
        status: false,
      });
    } else if (state.email !== state.confirmEmail) {
      setValidation({
        message: t("appointment.EMAIL-VALIDATION.message3"),
        status: false,
      });
    } else {
      setValidation({ message: "", status: true });
    }
  }

  const handleChange = (e) => {
    let { id, value } = e.target;
    value = e.target.type === "checkbox" ? e.target.checked : e.target.value;
    setState({
      ...state,
      [id]: value,
    });
  };

  const canContinue = () => {
    if (state.none) {
      return state.none;
    } else {
      return validation.status;
    }
  };

  return (
    <div className="body_content">
      <div className="inner_body">
        <h3 className="headtitle mb-4">{t("onboard.EMAIL.question")}</h3>
        <div className="fill_form light_fill_form">
          <div className="field_group field_lbl_active">
            <label className="field_lbl">{t("onboard.EMAIL.inputLbl1")}</label>
            <input
              type={inputType1}
              className="field_input"
              placeholder=""
              name="email"
              id="email"
              disabled={state.email.includes("XX")}
              onChange={handleChange}
              value={state.email}
              autoComplete="off"
              onFocus={() => setInput1Type("email")}
              onBlur={() => setInput1Type("password")}
            />
          </div>
          <h3 className="headtitle mb-4">{t("onboard.EMAIL.inputLbl2")}</h3>
          <div className="field_group field_lbl_active">
            <label className="field_lbl">{t("onboard.EMAIL.inputLbl3")}</label>
            <input
              type={inputType2}
              className="field_input"
              placeholder=""
              name="confirmEmail"
              id="confirmEmail"
              onChange={handleChange}
              disabled={state.confirmEmail.includes("XX")}
              value={state.confirmEmail}
              autoComplete="off"
              onFocus={() => setInput2Type("email")}
              onBlur={() => setInput2Type("password")}
            />
            {validation.status === true && !state.none && (
              <span className="icon">
                <GreenTick className="img-fluid" />
              </span>
            )}
          </div>

          {validation.status !== true && state.confirmEmail !== "" && (
            <span className="txt_help " style={{ color: "red" }}>
              {validation.message}
            </span>
          )}

          <div className="form-check mt-5">
            <input
              type="checkbox"
              className="form-check-input"
              id="none"
              name="option1"
              value={state.none}
              onChange={handleChange}
              disabled={state.email}
            />
            <label className="form-check-label">
              <p>
                {t("login.EMAIL.message1")} <br />
                {t("login.EMAIL.message2")}
              </p>
            </label>
          </div>

          <div className="btn_block d-flex justify-content-center bottom_button">
            <button
              className="btn btn_primary"
              onClick={() => onSubmitHandler(state)}
              disabled={!canContinue()}
            >
              {t("login.DOBSTEP.button")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Email;
